import React from 'react'
import { connect } from 'dva'
import { Switch } from 'dva/router'
import styles from './commonLayout.module.less'
import ShowModal from "@/components/ShowModal"
import UnitSelectModal from "../routes/home/components/modal/unitSelectModal"
import HandleAlarmModal from "../routes/home/components/modal/handleAlarm"
import SetHtmlFontSize from "./SetHtmlFontSize";

@connect(({ global, commonModel }) => ({
    user: global.user,
    unitSelectVisible: commonModel.unitSelectVisible,
    alarmInfo: commonModel.alarmInfo,
}))
export default class CommonLayout extends React.PureComponent {
    state = {
        userGet: false,
    }
    componentDidMount() {
        this.props.dispatch({ type: 'global/getUserInfo' });
        this.props.dispatch({ type: "DICT/init", payload: { data: { size: 9999 } } });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.userChange();
    }
    userChange = () => {
        const { user } = this.props;
        let userId = user && user.userInfo && user.userInfo.id ? user.userInfo.id : undefined;
        let unitId = user && user.unit && user.unit.id ? user.unit.id : undefined;
        if (userId && userId.length > 0) {
            let role = user.role;
            if (role && role.code === `ORGAN`) {
                this.setState({ userGet: true });
            } else {
                //非机构管理员直接跳转到主界面
                // window.location.href = `${window.location.origin}/enterprise/home/${unitId}`;
                window.location.href = `${window.location.origin}/#/home`;
            }
        }
    }
    render() {
        const { userGet } = this.state;
        const { routerData, unitSelectVisible, alarmInfo } = this.props;
        const { childRoutes } = routerData;
        SetHtmlFontSize();
        const unitSelectProps = {
            visible: unitSelectVisible,
            onClose: () => this.props.dispatch({ type: 'commonModel/changeUnitSelectVisible' })
        }
        /** 警情处理 */
        const handleAlarmProps = {
            ...alarmInfo,
            onClose: () => this.props.dispatch({ type: 'commonModel/changeAlarmInfoVisible' })
        }
        if (userGet) {
            return (
                <div className={styles.main}>
                    <ShowModal {...unitSelectProps}><UnitSelectModal /></ShowModal>
                    <ShowModal {...handleAlarmProps} ><HandleAlarmModal /></ShowModal>
                    <Switch>{childRoutes}</Switch>
                </div>
            )
        } else {
            return ``;
        }

    }
}
